import type { Debt } from '@/types'
import { PAID_OFF_TOLERANCE } from './tolerances'

/**
 * v0.8.48 — Canonical "is this debt cleared?" predicate.
 *
 * A debt counts as paid off when EITHER:
 *   - it has an explicit `paidOffAt` stamp (v0.8.41 manual mark or
 *     `closeCurrentMonth` auto-stamp), OR
 *   - its balance is at or below the FP tolerance (a half-cent). The
 *     legacy branch keeps zero-balance debts from pre-v0.8.41 closes
 *     surfaced as cleared without needing a migration to backfill
 *     stamps.
 *
 * Extracted from 5 duplicated inline expressions across the codebase
 * (`useDebts`, `registryAnalytics`, `DebtTable` x2,
 * `RecoveryProgressCard`) — the audit flagged this as a drift target.
 * The strict `balance === 0` check used inline was already slightly
 * off: an ending-balance snapshot at $0.003 residue (below the
 * `closeCurrentMonth` FP tolerance) rendered as "still owing $0"
 * instead of cleared. Threshold check via `PAID_OFF_TOLERANCE` matches
 * the rest of the codebase.
 */
export function isPaidOff(debt: Pick<Debt, 'paidOffAt' | 'balance'>): boolean {
  if (debt.paidOffAt !== undefined) return true
  return debt.balance <= PAID_OFF_TOLERANCE
}
